import { useDroppable } from '@progress/kendo-react-common';
import * as React from 'react';
import { EmployeeTemplateOptionModel } from '../../../../../models/EmployeeTemplateOptionModel';
import { DragContext, DropContext } from './DragContext';
import { List, ListProps } from './List';
import { ListItem } from './ListItem';
import { OptionPanel } from './OptionPanel';

export interface DroppableListProps extends ListProps {
  data: EmployeeTemplateOptionModel;
  saveOptionNewName?: (optionId: number, optionName: string) => void;
  removeOption?: (option: EmployeeTemplateOptionModel) => void;
  onDrop?: Function;
}

export const DroppableList = (props: DroppableListProps) => {
  const list = React.useRef<HTMLUListElement>(null);
  const dropInstance = React.useRef<{
    element: React.RefObject<HTMLElement | null>;
    data: EmployeeTemplateOptionModel;
  }>(null);
  React.useImperativeHandle(dropInstance, () => ({
    element: list,
    data: props.data,
  }));

  const [drag] = React.useContext(DragContext);
  const [drop, setDrop] = React.useContext(DropContext);

  const handleDragEnter = () => {
    if (!props.children || !React.Children.count(props.children)) {
      setDrop(dropInstance.current);
    }
  };

  const handleDragLeave = () => {
    if (!props.children || !React.Children.count(props.children)) {
      setDrop(null);
    }
  };

  const handleDrop = () => {
    if (props.onDrop) {
      props.onDrop();
    }
  };

  useDroppable(list, {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
  });

  return (
    <List ref={list} {...props}>
      {props.children && React.Children.count(props.children)
        ? props.children
        : drag &&
          drop &&
          drop.data.optionId === props.data.optionId && (
            <ListItem data={drag.data} style={{ opacity: '0.7' }}>
              <OptionPanel
                option={drag.data}
                saveOptionNewName={drag.saveOptionNewName}
                removeOption={drag.removeOption}
              ></OptionPanel>
            </ListItem>
          )}
    </List>
  );
};
